import CatalogTileCard from "../../common/catalog/CatalogTileCard";
import { getClipCatalogAccessProps } from "../clipCatalogAccess";

export default function ClipCatalogTile({
	clip,
	to,
	actionLabel = "مشاهده کلیپ",
}) {
	const { accessBadgeText, accessUnlocked } = getClipCatalogAccessProps(clip);
	const href = to ?? `/video_clip_detail/${clip?.id}/`;

	return (
		<CatalogTileCard
			to={href}
			title={clip?.title ?? ""}
			imageUrl={clip?.image_url}
			actionLabel={actionLabel}
			accessBadgeText={accessBadgeText}
			accessUnlocked={accessUnlocked}
			showDoctorRow={false}
			imageOverlay="play"
			footerWithPlayIcon
		/>
	);
}
